<template>
  <div class="studyPathStudy">
    <title-widge :title="title" :subTitle="subTitle"></title-widge>
    <div class="conts">
      <div class="studyRoute">
        <div class="outlineBox">
          <el-tabs
            :tab-position="tabPosition"
            style="height: 659px;"
            @tab-click="handleClick"
          >
            <el-tab-pane label v-for="(item, index) in tableData" :key="index">
              <div slot="label" class="outlineTitle">
                <p>{{ item.title }}</p>
                <span :title="item.subTitle">{{ item.subTitle }}</span>
              </div>
              <div class="outlineeInfo">
                <div v-for="(val, num) in item.details" :key="num">
                  <em class="courseOutTitle">{{ val.title }}</em>

                  <ul class="courseOutList">
                    <li v-for="(v, n) in val.details" :key="n" :title="v">
                      {{ v }}
                    </li>
                  </ul>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
        <!-- <div class="divStudyBtn" @click="qimoChatClick">
          <a>马上学习</a>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import titleWidge from "./titleWidge";
import { elTabsAddEventListener } from "./../../../../js/tools";
export default {
  components: {
    titleWidge,
  },
  data() {
    return {
      tabPosition: "left",
      tableData: [],
    };
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    subTitle: {
      type: String,
      default: "",
    },
    data: {
      type: Array,
      default: function() {
        return [];
      },
    },
  },
  watch: {
    data(arr) {
      this.tableData = arr.map((item, index) => {
        return { ...item, ...this.titleConvert(item.title, index) };
      });
      setTimeout(() => {
        elTabsAddEventListener(document, arr.length);
      }, 1000);
    },
  },
  methods: {
    handleClick(val) {
      this.$trackEvent(
        this.tableData[val.index].titles,
        "点击",
        this.tableData[val.index].titles
      );
    },
    qimoChatClick() {
      this.$trackEvent("马上学习", "点击", "马上学习");
      window.qimoChatClick();
    },
    titleConvert(title, index) {
      let obj = { title: "第" + Number(index + 1) + "章", subTitle: title };
      if (title.indexOf("（") > 0) {
        let index1 = title.indexOf("：");
        let index2 = title.indexOf("（");
        let dayNum = title.substr(index2);
        let realTitle = title.slice(0, index1) + dayNum;
        let subTitle = title.slice(index1 + 1, index2);
        obj = { title: realTitle, subTitle: subTitle };
      }
      return obj;
    },
  },
};
</script>

<style lang="scss">
@import "./../scss/studyPathWidge.scss";
</style>
